var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1264L6.36782 18.7586C6.2069 18.9195 6.01916 19 5.8046 19C5.59004 19 5.4023 18.9195 5.24138 18.7586C5.08046 18.5977 5 18.41 5 18.1954C5 17.9808 5.08046 17.7931 5.24138 17.6322L10.8736 12L5.24138 6.36782C5.08046 6.2069 5 6.01916 5 5.8046C5 5.59004 5.08046 5.4023 5.24138 5.24138C5.4023 5.08046 5.59004 5 5.8046 5C6.01916 5 6.2069 5.08046 6.36782 5.24138L12 10.8736L17.6322 5.24138C17.7931 5.08046 17.9808 5 18.1954 5C18.41 5 18.5977 5.08046 18.7586 5.24138C18.9195 5.4023 19 5.59004 19 5.8046C19 6.01916 18.9195 6.2069 18.7586 6.36782L13.1264 12L18.7586 17.6322C18.9195 17.7931 19 17.9808 19 18.1954C19 18.41 18.9195 18.5977 18.7586 18.7586C18.5977 18.9195 18.41 19 18.1954 19C17.9808 19 17.7931 18.9195 17.6322 18.7586L12 13.1264Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.01a10440e2ae9932ca7291b4d1bd7407.svg";
export { ForwardRef as ReactComponent };